import { CustomCell } from '../../components/custom-cell';
import { getStringOperators } from '../../utils/getStringOperators';
import { getNumericOperators } from '../../utils/getNumericOperators';

export const TABLE_COLUMNS = trailerTypes => {
	return [
		{
			headerName: '#',
			field: 'id',
			width: 100,
			minWidth: 100,
			align: 'center',
			headerAlign: 'center',
			type: 'number',
			cellClassName: 'id',
			filterOperators: getNumericOperators(),
			renderCell: params => CustomCell(params),
		},
		{
			headerName: 'Юр. лицо',
			field: 'legal',
			flex: 2,
			filterOperators: getStringOperators(),
			valueGetter: (value, row) => {
				if (!row.legal) {
					return value;
				}

				return row.legal.name;
			},
		},
		{
			headerName: 'Модель',
			field: 'name',
			flex: 2,
			filterOperators: getStringOperators(),
			renderCell: params => CustomCell(params),
		},
		{
			headerName: 'Тип прицепа',
			field: 'type_id',
			flex: 1,
			sortable: false,
			type: 'singleSelect',
			valueOptions: trailerTypes,
			getOptionValue: value => value?.id,
			getOptionLabel: value => value?.name ?? 'Все',
			valueGetter: (value, row) => {
				if (!row.type) {
					return value;
				}

				return row.type.id;
			},
		},
		{ headerName: 'Номер', field: 'number', flex: 1, sortable: false, filterOperators: getStringOperators() },
		{ headerName: 'Vin номер', field: 'vin', flex: 1, sortable: false, filterOperators: getStringOperators() },
	];
};

export const REQUEST_ERROR_MESSAGE = 'Ошибка сервера';
